<template>
  <div class="recharge-details">
    <div class="breadcrumb" style="background: #fff">在线充值</div>
    <div class="order-detail-basic">
      <el-form :model="storeInfo" ref="numberValidateForm" label-width="100px">
        <!-- <el-form-item label="平台号：">
              <span>{{ storeInfo.code }}</span>
            </el-form-item>
            <el-form-item label="平台名称：">
              <span>{{ storeInfo.name }}</span>
            </el-form-item> -->
        <el-form-item label="平台号:" prop="num">
          <el-autocomplete v-model="code" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect">
          </el-autocomplete>
          <el-button @click="verifyStore" style="margin-right:10px" round>验证平台</el-button>
          <span v-show="show">平台名称:{{ storeName }}</span>
        </el-form-item>
        <el-form-item label="充值余额：">
          <span>{{ myBalance }}</span>
        </el-form-item>
        <el-form-item label="充值金额：">
          <el-input v-model="amount"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button round type="primary" @click="submitRecharge('CMBCHINA')">确认充值</el-button>
    </div>
    <CombinedDialog ref="combinedRef"></CombinedDialog>
  </div>
</template>
<script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index.vue'
import { storeQueryListByCode, storeQueryByStoreCode, queryByStoreId } from '@/api/crm'
import { chargeOnlinePrepay, adminConfigGet, queryByUserId, getByStoreIds } from '@/api/epay'
export default {
  name: 'recharge',
  components: {
    CombinedDialog
  },
  data () {
    return {
      code: '', // 平台号
      storeName: '',
      fromType: '', // 跳转过来的页面
      type: 'amount', // 充值类型
      storeInfo: {
        id: null,
        code: '',
        name: ''
      },
      amount: null,
      remark: '',
      storeId: null,
      chargeLine: '',
      myBalance: ''
    }
  },
  created () {
    this.fromType = this.$route.query.type
    console.log(' this.fromType', this.fromType)
    this.getStoreMsg()
    this.getConfig()
  },
  watch: {
    code () {
      this.show = false
    }
  },
  methods: {
    querySearchAsync (queryString, cb) {
      let val = queryString.replace(/\s*/g, '')
      if (!val) {
        return
      }
      storeQueryListByCode(val).then(res => {
        res.data.data.forEach(item => {
          item.value = item.code
        })
        cb(res.data.data)
      })
    },
    // 验证平台
    async verifyStore () {
      this.code = this.code.replace(/\s*/g, '')
      if (!this.code) {
        this.$message.error('请输入平台号')
        return
      }
      await storeQueryByStoreCode(this.code).then(async res => {
        if (res.data.data.exist) {
          this.storeId = res.data.data.id
          this.storeName = res.data.data.name
          this.show = true
          await getByStoreIds(this.storeId).then((res) => {
            if (res.data.success) {
              this.myBalance = res.data.data?.balances.ACCT?.balance // 充值余额
            } else {
              this.myBalance = ''
            }
          })
        } else {
          this.$message.error('平台不存在')
        }
      })
    },
    handleSelect (item) {
      this.storeId = item.id
    },
    getConfig () {
      adminConfigGet('WARNING_LINE_CHARGE').then(res => {
        if (res.data.success) {
          this.chargeLine = res.data.data.value
        }
      })
    },
    getStoreMsg () {
      queryByStoreId(this.storeId).then(res => {
        if (res.data.success) {
          this.storeInfo = res.data.data
        }
      })
      // 我的余额
      queryByUserId(this.storeId).then(res => {
        if (res.data.success) {
          this.myBalance = res.data.data.balances.ACCT.balance
        }
      })
    },
    submitRecharge (paymentChannel, paymentType) {
      console.log(paymentChannel, paymentType)
      let amount = this.type === 'chargeLine' ? this.chargeLine : this.amount
      if (amount === null) {
        this.$notify({ title: '失败', message: '充值金额不能为空', type: 'error' })
        return
      }
      if (amount <= 0) {
        this.$notify({ title: '失败', message: '充值金额需大于零', type: 'error' })
        return
      }

      let reg = /^([1-9]\d*|0)(\.\d{1,2})?$/
      if (!reg.test(amount)) {
        this.$notify({ title: '失败', message: '请输入正确的金额，最多精确到分', type: 'error' })
        return
      }

      if (+amount < +this.chargeLine) {
        this.$notify({ title: '失败', message: '起充金额' + this.chargeLine + '元', type: 'error' })
        return
      }
      console.log(111)
      chargeOnlinePrepay({
        amount: amount,
        remark: this.remark,
        paymentChannel: paymentChannel,
        // paymentType: paymentType,
        storeId: this.storeId
      }).then(res => {
        console.log(res)
        if (res.data.success) {
          console.log(res.data)
          let prepay = res.data.data.prepay
          let charge = res.data.data.order
          this.$refs.combinedRef.show('rechargeOnline', '', {
            amount: prepay.amount,
            qrcode: prepay.qrcode,
            orderId: charge.orderId,
            tradeMethod: charge.tradeMethod
          }, this.fromType)
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~'>>>';

.recharge-details {
  .el-input {
    @{deep} .el-input__inner {
      //color: #F56C6C;
      -moz-appearance: textfield;
    }

    @{deep} .el-input__inner::-webkit-inner-spin-button,
    @{deep} .el-input__inner::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}
</style>
